import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import type { CompanySourceRecord } from "../../../api/client.ts";
import CodeBlock from "../../../components/CodeBlock.tsx";
import CountryName from "../../../components/CountryName.tsx";
import FormattedDate from "../../../components/FormattedDate.tsx";
import Panel from "../../../components/Panel.tsx";
import ExpandableRow from "../../../components/table/ExpandableRow.tsx";
import ScrollTable from "../../../components/table/ScrollTable.tsx";

function SourceRow({ source }: { source: CompanySourceRecord }) {
  return (
    <ExpandableRow
      colSpan={6}
      cells={
        <>
          <TableCell>{source.source}</TableCell>
          <TableCell>{source.external_id}</TableCell>
          <TableCell><CountryName code={source.country} /></TableCell>
          <TableCell>{source.confidence != null ? source.confidence.toFixed(2) : "-"}</TableCell>
          <TableCell><FormattedDate value={source.fetched_at} /></TableCell>
        </>
      }
    >
      <Typography variant="subtitle2" gutterBottom>
        Raw data
      </Typography>
      <CodeBlock maxHeight={400}>
        {JSON.stringify(source.raw_data, null, 2)}
      </CodeBlock>
    </ExpandableRow>
  );
}

interface SourceRecordsCardProps {
  sources: CompanySourceRecord[] | undefined;
}

export default function SourceRecordsCard({ sources }: SourceRecordsCardProps) {
  if (!sources || sources.length === 0) return null;
  return (
    <Panel title="Source records" count={sources.length} sx={{ mb: 3 }}>
      <ScrollTable>
        <TableHead>
          <TableRow>
            <TableCell />
            <TableCell>Source</TableCell>
            <TableCell>External ID</TableCell>
            <TableCell>Country</TableCell>
            <TableCell>Confidence</TableCell>
            <TableCell>Fetched</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sources.map((s) => (
            <SourceRow key={s.id} source={s} />
          ))}
        </TableBody>
      </ScrollTable>
    </Panel>
  );
}
